import WordCloud from "./word-cloud";

export default WordCloud;